import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: resolve => require(['@/pages/home_page'], resolve)
    },
    {
      path: '/order_page',
      name: 'orderPage',
      component: resolve => require(['@/pages/order_page'], resolve)
    },
    {
      path: '/my_page',
      name: 'myPage',
      component: resolve => require(['@/pages/my_page'], resolve)
    },
    {
      path: '/submit_order',
      name: 'submitOrder',
      component: resolve => require(['@/pages/submit_order'], resolve)
    },
    {
      path: '/person_info',
      name: 'personInfo',
      component: resolve => require(['@/pages/person_info'], resolve)
    },
    {
      path: '/add_person',
      name: 'addPerson',
      component: resolve => require(['@/pages/add_person'], resolve)
    },
    {
      path: '/order_detail',
      name: 'orderDetail',
      component: resolve => require(['@/pages/order_detail'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js